import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type HomeDashboardState = {
  status: { loading: boolean; error: string };
  dashboardData: any;
  calenderData: any;
  activitiesList: any;
  helloCardData: any;
  filterData: any;
  helloCardPageData: any;
  workflowHelloCards: any;
  inputFields: any;
  leadDetails: any;
  activityDetails: any;
  loading: boolean;
  snapShotMetrics: any;
  snapShotCards: any;
};

const initialState: HomeDashboardState = {
  status: { loading: false, error: '' },
  dashboardData: {},
  activitiesList: [],
  calenderData: [],
  helloCardData: [],
  workflowHelloCards: [],
  helloCardPageData: {},
  filterData: {},
  inputFields: [],
  leadDetails: [],
  activityDetails: [],
  loading: false,
  snapShotCards: [],
  snapShotMetrics: [],
};

const homeDashboardSlice = createSlice({
  name: 'homeDashboard',
  initialState,
  reducers: {
    setHomeDashboardLoading: (state: HomeDashboardState) => {
      state.status = { loading: true, error: '' };
    },

    setCalendarData: (
      state: HomeDashboardState,
      action: PayloadAction<any>,
    ) => {
      state.calenderData = action.payload;
    },

    setCalendarActivityList: (
      state: HomeDashboardState,
      action: PayloadAction<any>,
    ) => {
      state.activitiesList = action.payload;
    },

    setHelloCardData: (
      state: HomeDashboardState,
      action: PayloadAction<any>,
    ) => {
      state.helloCardData = action.payload;
    },

    setHelloCardPageData: (
      state: HomeDashboardState,
      action: PayloadAction<any>,
    ) => {
      const { pageCode, categories } = action.payload;
      state.helloCardPageData[pageCode] = categories;
    },

    setFilterData: (state: HomeDashboardState, action: PayloadAction<any>) => {
      state.filterData = action.payload;
    },
    setInputFields: (state, action: PayloadAction<any>) => {
      state.inputFields = action.payload;
    },

    setLeadDetails: (state, action: PayloadAction<any>) => {
      state.leadDetails = action.payload;
    },

    setCalendarActivityDetails: (state, action: PayloadAction<any>) => {
      state.activityDetails = action.payload;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setWorkflowHelloCards: (
      state: HomeDashboardState,
      action: PayloadAction<any>,
    ) => {
      state.workflowHelloCards = action.payload;
    },

    setPerformanceMetrics: (state, action: PayloadAction<any>) => {
      state.snapShotMetrics = action.payload;
    },

    setPerformanceSnapshotCards: (state, action: PayloadAction<any>) => {
      state.snapShotCards = action.payload;
    },

    resetHomeDashboard: () => initialState,
  },
});

export const {
  setHomeDashboardLoading,
  setCalendarData,
  setCalendarActivityList,
  setHelloCardData,
  setFilterData,
  setHelloCardPageData,
  setInputFields,
  setLeadDetails,
  setCalendarActivityDetails,
  setLoading,
  setWorkflowHelloCards,
  setPerformanceMetrics,
  setPerformanceSnapshotCards,
  resetHomeDashboard,
} = homeDashboardSlice.actions;
const reducer = {
  homeDashboard: homeDashboardSlice.reducer,
};
export default reducer;
